class InstantFinance {
  constructor(instantFinance) {
    this.instantFinance = document.getElementById(instantFinance);
    this.init();
  }

  init() {
    if (this.instantFinance) {
      $(this.instantFinance)
        .find("#submit-form")
        .click(() => this.validateCalcuAll());

      $(this.instantFinance).find("#reset-form").click(this.resetAll);
      $(this.instantFinance).find("#goods").focus(this.addGoodsValue);
      this.callfn();
      //   this.presizeValue();
    }
  }

  resetAll() {
    $("#goods").val("");
    $("#tenure").val("");
    $("#answer").val("");
    $(".errmsg").html("");
    $(".errorMsgTenure").html("");
    $("#tenure").removeAttr('style');
    $("#goods").removeAttr('style');
  }

  addGoodsValue() {
    $("#goods").val("2000");
  }

  validateCalcuAll() {
    var allValid = true;
    var errorMsg = $(this.instantFinance).attr("data-error-message");
    var errorMsgTenure = $(this.instantFinance).attr(
      "data-error-message-Tenure"
    );
    var errorMsgNumber = $(this.instantFinance).attr(
      "data-error-message-number"
    );
    var errorMsgMonths = $(this.instantFinance).attr(
      "data-error-message-months"
    );
    var errorMsgMaxTenure = $(this.instantFinance).attr(
      "data-error-message-max-tenure"
    );
    var errorMsg3Multiple = $(this.instantFinance).attr(
      "data-error-message-3-multiples"
    );
    $(".errmsg").html("");
    $("#answer").val("");
    if ($("#goods").val() == "") {
      $("#goods").css("border", "solid 1px #f00");
      $("#goods").after(errorMsg);
      $(this.instantFinance).find("#errorMsg").innerHTML = errorMsg;
      allValid = false;
    } else {
      $("#goods").css("border", "solid 1px #214b7d");
    }

    if ($("#tenure").val() == "") {
      $("#tenure").after(errorMsgTenure);
      allValid = false;
    } else {
      var tenure = parseInt($("#tenure").val(), 10);
      var div_ans = tenure % 3;
      if (isNaN($("#tenure").val())) {
        $("#tenure").css("border", "solid 1px #f00");
        $("#tenure").after(errorMsgNumber);
        allValid = false;
      } else if (parseInt($("#tenure").val(), 10) < 3) {
        $("#tenure").css("border", "solid 1px #f00");
        $("#tenure").after(errorMsgMonths);
        allValid = false;
      } else if (parseInt($("#tenure").val(), 10) > 48) {
        $("#tenure").css("border", "solid 1px #f00");
        $("#tenure").after(errorMsgMaxTenure);
        allValid = false;
      } else if (div_ans != 0) {
        $("#tenure").css("border", "solid 1px #f00");
        $("#tenure").after(errorMsg3Multiple);
        allValid = false;
      }
      if (allValid) {
        var profit = 0.0125;
        var goods = parseInt($("#goods").val(), 10);
        var tenure = parseInt($("#tenure").val(), 10);
        var ans = 0;
        ans =
          (Number(goods) * Number(profit) * Number(tenure) + Number(goods)) /
          Number(tenure);
        if (ans != "") {
          $("#answer").val(this.addCommas(ans.toFixed(2)));
        } else {
          $("#answer").val(0);
        }
        $("#tenure").css("border", "solid 1px #214b7d");
      } else {
        return false;
      }
    }
  }

  callfn(fname, goods, tenure) {}

  presizeValue(th) {
    num = th.value;
    if (num != "") {
      th.value = parseFloat(num).toFixed(2);
      if (th.value != 0) {
        $("#goodsVal").val(th.value);
      } else {
        $("#goodsVal").val("");
      }
      th.value = this.addCommas(th.value) + " AED";
    } else {
      $("#goodsVal").val("");
    }
    return false;
  }

  addCommas(nStr) {
    nStr += "";
    var x = nStr.split(".");
    var x1 = x[0];
    var x2 = x.length > 1 ? "." + x[1] : "";
    var rgx = /(\d+)(\d{3})/;
    while (rgx.test(x1)) {
      x1 = x1.replace(rgx, "$1" + "," + "$2");
    }
    return x1 + x2;
  }
}

export default InstantFinance;
